/* eslint-env browser */
import { hasAnalyticsConsent, subscribeConsent } from "./consent";

let initialized = false;
let currentUserId;

function queueGoogleTag() {
  // Google tags use an Arguments object for queued commands.
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

function setUserId(userId) {
  if (userId === currentUserId) return;

  try {
    window.dataLayer = window.dataLayer || [];
    const parameters = { user_id: userId };
    if (typeof window.gtag === "function") {
      try {
        window.gtag("set", parameters);
      } catch (error) {
        // Keep identity updates queued even when a tag wrapper fails.
        queueGoogleTag("set", parameters);
      }
    } else {
      // Queue the same command while Google tags load through GTM.
      queueGoogleTag("set", parameters);
    }
    window.dataLayer.push({ event: "user_id_updated", ...parameters });
    currentUserId = userId;
  } catch (error) {
    // Analytics must not interrupt authentication, even if Google tags fail.
    // eslint-disable-next-line no-console
    console.warn("GA4 user identification failed:", error);
  }
}

export default function initGa4UserId(store) {
  // Match the existing GTM tracking environment, independently of PostHog.
  if (initialized || process.env.NODE_ENV !== "production") return;
  initialized = true;

  const identifyUser = (user) => {
    if (hasAnalyticsConsent() && user && user.id) setUserId(String(user.id));
  };

  identifyUser(store.getters.customer);
  store.subscribe((mutation) => {
    if (mutation.type === "AUTH_SUCCESS") identifyUser(mutation.payload);
    if (mutation.type === "AUTH_LOGOUT" && hasAnalyticsConsent() && currentUserId != null) {
      setUserId(null);
    }
  });
  subscribeConsent((next) => {
    if (next.analytics) identifyUser(store.getters.customer);
    else if (currentUserId != null) {
      // Clear Google's configuration without emitting an analytics event.
      queueGoogleTag("set", { user_id: null });
      window.dataLayer.push({ user_id: null });
      currentUserId = null;
    }
  });
}
